import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Grid, GridItem, Image, Text, CloseButton } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
const getGridConfig = ({ quantityLabel, itemPriceLabel }) => ({
    2: {
        sm: {
            areas: `
                    ". . remove"
                    "img brand brand"
                    "img name name"
                    "img price price"
                    "img quantity quantity"
                `,
            columns: 'auto 1fr auto',
            removeButton: 'icon',
            image: {
                width: 100,
                height: 66,
            },
            quantity: {
                display: 'inline',
                label: `${quantityLabel}: `,
            },
        },
        lg: {
            areas: `
                    ". . remove"
                    "img brand brand"
                    "img name name"
                    "img price price"
                    "img quantity quantity"
                `,
            columns: 'auto 1fr auto',
            removeButton: 'icon',
            image: {
                width: 100,
                height: 85,
            },
            quantity: {
                display: 'inline',
                label: `${quantityLabel}: `,
            },
        },
    },
    3: {
        sm: {
            areas: `
                    "img . . remove"
                    "img brand brand brand"
                    "img name name name"
                    "img price price price"
                    "img details details details"
                    "img wishlist wishlist wishlist"
                    "meta meta meta meta"
                `,
            columns: 'auto 1fr 1fr auto',
            rows: '5px auto auto auto auto auto auto',
            removeButton: 'icon',
            image: {
                width: 100,
                height: 141,
            },
        },
        lg: {
            areas: `
                    "img brand brand price"
                    "img name name price"
                    "img details details price"
                    "img meta wishlist remove"
                `,
            columns: 'auto 1fr auto auto',
            rows: 'auto auto 1fr auto',
            removeButton: 'text',
            image: {
                width: 145,
                height: 175,
            },
            price: {
                label: itemPriceLabel,
                display: 'block',
                align: 'end',
            },
        },
    },
    4: {
        sm: {
            areas: `
                    "img . remove"
                    "img brand price"
                    "img name price"
                    "img details ."
                    "img wishlist ."
                    "meta meta meta"
                `,
            columns: 'auto 1fr auto',
            removeButton: 'icon',
            image: {
                width: 100,
                height: 110,
            },
            quantity: {
                display: 'block',
                label: quantityLabel,
                align: 'center',
            },
            price: {
                display: 'block',
                align: 'end',
            },
        },
        lg: {
            areas: `
                    "img brand quantity price"
                    "img name quantity price"
                    "img details quantity price"
                    "img meta wishlist remove"
                `,
            columns: 'auto 1fr auto auto',
            rows: 'auto auto 1fr auto',
            removeButton: 'text',
            image: {
                width: 145,
                height: 175,
            },
            quantity: {
                display: 'block',
                label: quantityLabel,
                align: 'center',
            },
            price: {
                label: itemPriceLabel,
                display: 'block',
                align: 'end',
            },
        },
    },
    5: null,
});
export const HorizontalProductCardReadOnly = (props) => {
    const intl = useIntl();
    const { image, brand, name, details = [], regularPrice, salePrice, quantity, metaText, } = props;
    const { columns = 3, size = 'lg' } = props;
    const { onRemove, onAddToWishlist } = props;
    const quantityLabel = intl.formatMessage({ id: 'cart.item.quantity' });
    const itemPriceLabel = intl.formatMessage({ id: 'cart.item.price' });
    const grid = getGridConfig({ quantityLabel, itemPriceLabel });
    const gridSettings = grid[columns]?.[size];
    if (!gridSettings) {
        return null;
    }
    const gridTemplateAreas = gridSettings.areas;
    const gridTemplateColumns = gridSettings.columns;
    const gridTemplateRows = gridSettings.rows;
    const removeButtonType = gridSettings.removeButton;
    const imageSize = gridSettings.image;
    const quantityOptions = gridSettings.quantity;
    const priceOptions = gridSettings.price;
    const getGridItemDisplayValue = (area) => {
        const shouldHide = !gridTemplateAreas.includes(area);
        return shouldHide ? 'none' : undefined;
    };
    return (_jsx(Box, { children: _jsxs(Grid, { gridTemplateAreas: gridTemplateAreas, gridTemplateColumns: gridTemplateColumns, gridTemplateRows: gridTemplateRows, paddingY: 5, columnGap: 4, children: [_jsx(GridItem, { area: "img", children: _jsx(Image, { src: image?.src, alt: image?.alt, fit: "contain", width: imageSize.width, height: imageSize.height, onClick: image?.onClickImage, cursor: image?.onClickImage ? 'pointer' : undefined }) }), _jsx(GridItem, { area: "brand", fontSize: size === 'lg' ? 'xs' : 'xxs', color: "text-muted", children: brand }), _jsx(GridItem, { area: "name", textStyle: 'Desktop/Body-Default', fontSize: size === 'lg' ? 'base' : 'xs', children: name }), _jsxs(GridItem, { area: "price", fontSize: size === 'lg' ? 'sm' : 'xs', textAlign: priceOptions?.align, children: [_jsx(Text, { as: priceOptions?.display === 'block' ? 'p' : 'span', fontSize: "xs", color: "text-muted", fontWeight: "extrabold", children: priceOptions?.label }), _jsx(Text, { as: priceOptions?.display === 'block' ? 'p' : 'span', mr: priceOptions?.display !== 'block' ? 1 : undefined, textDecoration: salePrice ? 'line-through' : undefined, children: regularPrice }), _jsx(Text, { as: priceOptions?.display === 'block' ? 'p' : 'span', color: "danger-med", children: salePrice })] }), _jsx(GridItem, { area: "remove", display: "flex", justifyContent: "end", children: onRemove && (_jsxs(_Fragment, { children: [removeButtonType === 'text' && (_jsx(Text, { textAlign: "end", textDecoration: "underline", fontSize: "xs", onClick: onRemove, cursor: "pointer", children: intl.formatMessage({ id: 'action.remove' }) })), removeButtonType === 'icon' && (_jsx(CloseButton, { size: "sm", isDisabled: false, onClick: onRemove }))] })) }), _jsx(GridItem, { area: "details", fontSize: size === 'lg' ? 'xs' : 'xxs', color: "text-muted", display: getGridItemDisplayValue('details'), children: details.map(({ name, value }, index) => (_jsxs(Text, { children: [name, ": ", value] }, index))) }), _jsxs(GridItem, { area: "quantity", fontSize: size === 'lg' ? 'xs' : 'xxs', textAlign: quantityOptions?.align, display: getGridItemDisplayValue('quantity'), children: [_jsx(Text, { as: quantityOptions?.display === 'block' ? 'p' : 'span', color: "text-muted", fontWeight: "extrabold", mr: 1, children: quantityOptions?.label }), _jsx(Text, { as: quantityOptions?.display === 'block' ? 'p' : 'span', children: quantity })] }), _jsx(GridItem, { area: "wishlist", display: getGridItemDisplayValue('wishlist'), children: onAddToWishlist && (_jsx(Text, { fontSize: size === 'lg' ? 'xs' : 'xxs', textDecoration: "underline", onClick: onAddToWishlist, cursor: "pointer", children: intl.formatMessage({ id: 'action.addToWishlist' }) })) }), _jsx(GridItem, { area: "meta", fontSize: size === 'lg' ? 'xs' : 'xxs', display: getGridItemDisplayValue('meta'), children: metaText })] }) }));
};
